var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 354,
    viewBox: "0 0 328 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 318,
    height: 344,
    rx: 159,
    stroke: "url(#paint0_linear_109_24)",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.688 244.234V99.25H209.688V244.234C209.688 257.734 206.922 269.125 201.391 278.406C195.859 287.688 188.219 294.766 178.469 299.641C168.812 304.422 157.703 306.812 145.141 306.812C132.578 306.812 121.422 304.656 111.672 300.344C101.922 296.031 94.2812 289.469 88.75 280.656C83.2188 271.844 80.4531 260.734 80.4531 247.328H107.594C107.594 255.953 109.188 263.031 112.375 268.562C115.562 274.094 119.969 278.172 125.594 280.797C131.312 283.422 137.828 284.734 145.141 284.734C152.266 284.734 158.641 283.234 164.266 280.234C169.984 277.141 174.484 272.594 177.766 266.594C181.047 260.5 182.688 253.047 182.688 244.234Z",
    fill: "#E1E1E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.84 107.266L150.831 252.236L123.834 251.862L125.842 106.892C126.03 93.3932 128.953 82.042 134.612 72.8382C140.271 63.6345 148.009 56.6629 157.826 51.9235C167.547 47.2765 178.689 45.04 191.25 45.2141C203.811 45.3882 214.937 47.6988 224.626 52.1459C234.315 56.5931 241.864 63.2609 247.273 72.1492C252.682 81.0374 255.293 92.1841 255.107 105.589L227.969 105.213C228.089 96.5888 226.593 89.4893 223.483 83.9144C220.372 78.3395 216.023 74.2007 210.435 71.4981C204.753 68.7941 198.256 67.3914 190.944 67.2901C183.82 67.1914 177.425 68.6029 171.759 71.5247C165.998 74.5389 161.435 79.023 158.071 84.9769C154.706 91.0247 152.962 98.4543 152.84 107.266Z",
    fill: "#41BBFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_24",
    x1: 99.7297,
    y1: -50.9178,
    x2: 285.053,
    y2: 409.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0833333,
    stopColor: "#41BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.96a8c64ced0bdbb85b94e324d3b55bef.svg";
export { ForwardRef as ReactComponent };